import React from 'react'
import { LoadingFeedChunkCard } from './FeedChunkCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './feedChunk.css'

const generateFeedCards = numEntries => {
  let entries = []
  for (let i = 0; i < numEntries; i++) {
    entries.push(
      <div key={i} className="feed-chunk__container">
        <div className="feed-chunk__card-column">
          <div className="feed-chunk__card-container">
            <LoadingFeedChunkCard />
          </div>
        </div>
      </div>
    )
  }
  return entries
}

const LoadingFeedChunk = ({ numEntries, isPrivate, isFirst, showPrivacy }) => {
  const feedCards = generateFeedCards(numEntries)
  return (
    <div className="feed-chunk">
      <div className="feed-chunk__head">
        <div className="feed-chunk__timeago feed-chunk__timeago--loading" />
        {isFirst && showPrivacy ? (
          isPrivate ? (
            <span className="feed-chunk__privacy">
              <FontAwesomeIcon icon={['fa', 'lock']} /> Private
            </span>
          ) : (
            <span className="feed-chunk__privacy">
              <FontAwesomeIcon icon={['fa', 'globe']} /> Public
            </span>
          )
        ) : null}
      </div>
      {feedCards}
    </div>
  )
}

export default LoadingFeedChunk



// WEBPACK FOOTER //
// ./src/domains/user/components/LoadingFeedChunk.js